// extracted by mini-css-extract-plugin
export default {"container":"GameCompetitors_container__lXWOG"};